import React from 'react'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { useCyberSource } from 'lib/core/hooks'
import { TokenResponseSuccess } from 'lib/core/hooks/useCyberSource'
import { FormikProps } from 'formik'
import { Toast } from 'lib/ui'
import {
  useCheckout,
  usePaymentMethod,
  CreditCardForm,
  CreditCardData,
  CreditCardFormValues
} from 'lib/modules/checkout'

import { Container } from './styled'

let values: CreditCardData
let formik: FormikProps<CreditCardFormValues>

export const Cybersource = () => {
  const { fetchCyberSourceData, setPaymentMethodOnCart } = useCyberSource()
  const { unlockCheckout, placeOrder, cartId } = useCheckout()

  usePaymentMethod(() => {
    formik.handleSubmit()
    formik.validateForm().then((errors) => {
      const hasErrors = !!Object.keys(errors).length
      if (!hasErrors) {
        fetchCyberSourceData(values, responseHandler)
          .then(() => {
            return true
          })
          .catch(e => {
            Toast.toastFailure({ messageId: 'checkout.cybersource.wrong' })
            throw new Error(e.message)
          })
      } else {
        Toast.toastFailure({ messageId: 'checkout.cybersource.invalidCreditCard' })
      }
    })
  })

  const responseHandler = function (response: TokenResponseSuccess) {
    if (!cartId) {
      return
    }

    const expDate = `${values.expMonth}-20${values.expYear}`
    if (response.error) {
      Toast.toastFailure({ messageId: 'checkout.cybersource.invalidCreditCard' })
      unlockCheckout()
    } else {
      setPaymentMethodOnCart({
        code: PAYMENT_METHOD.CYBERSOURCE,
        cardType: response.cardType,
        cvv: values.cvv,
        expDate: expDate,
        flexToken: response,
        cartId
      })
        .then(() => {
          placeOrder()
        })
        .catch(e => {
          throw new Error(e.message)
        })
      unlockCheckout()
    }
  }

  function handleChange (formValues: CreditCardData, formikObject: FormikProps<CreditCardFormValues>) {
    values = formValues
    formik = formikObject
  }

  return (
    <Container>
      <CreditCardForm
        onChange={handleChange}
      />
    </Container>
  )
}
